export default class ManageInvestigationController {
  constructor(investigation, investigationInteractor, eventsService, emailInteractor, close) {
    this.investigation = investigation;
    this.investigationInteractor = investigationInteractor;
    this.eventsService = eventsService;
    this.emailInteractor = emailInteractor;
    this.close = close;
  }

  openReports() {
    return new Promise((resolve, reject) => {
      this.investigationInteractor.openReports(this.investigation)
        .then(() => {
          this.eventsService.publishSystemMessage('Reports have been opened to participants.');
          resolve();
        }, () => {
          this.eventsService.publishSystemError('Failed to open reports to participants.');
          reject();
        });
    });
  }

  closeReports() {
    return new Promise((resolve, reject) => {
      this.investigationInteractor.closeReports(this.investigation)
        .then(() => {
          this.eventsService.publishSystemMessage('Reports have been closed to participants.');
          resolve();
        }, () => {
          this.eventsService.publishSystemError('Failed to close reports to participants.');
          reject();
        });
    });
  }

  sendReminder() {
    return new Promise((resolve, reject) => {
      let msg = window.prompt('Enter your reminder message');
      if (msg) {
        this.emailInteractor.sendInvestigationReminder(msg, this.investigation).then(() => {
          this.eventsService.publishSystemMessage('Investigation reminder successfully sent');
          resolve();
        }, () => {
          this.eventsService.publishSystemError('Failed to send reminder');
          reject();
        });
      }
    });
  }
}